"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSwitcherItemsList = void 0;
var app_1 = require("app");
var React = __importStar(require("react"));
var GoogleAnalytics_1 = require("../GoogleAnalytics");
var AppSwitcherItemsList = function (props) {
    var items = props.items, listClass = props.listClass, itemClass = props.itemClass, userId = props.userId;
    var checkMark = "/static/images/tick_language.svg";
    // Function to get place name from latitude and longitude asynchronously
    var getPlaceNameAsync = function (latitude, longitude) { return __awaiter(void 0, void 0, void 0, function () {
        var API_KEY, url, response, data, results, address, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    API_KEY = 'AIzaSyCrQkLHt22A920N-JrjzXYWNASKZTUwVQo';
                    url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=".concat(latitude, ",").concat(longitude, "&key=").concat(API_KEY);
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (data.status === 'OK') {
                        results = data.results;
                        if (results && results.length > 0) {
                            address = '';
                            if (results.length > 0) {
                                address = results[0].formatted_address;
                            }
                            return [2 /*return*/, address];
                        }
                        else {
                            return [2 /*return*/, ""];
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error fetching place name:", error_1);
                    return [2 /*return*/, ""];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    function getPosition() {
        return new Promise(function (resolve, reject) {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        });
    }
    function getCurrentPlaceName() {
        return __awaiter(this, void 0, void 0, function () {
            var position, placeName, error_2, defaultLatitude, defaultLongitude;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 7]);
                        return [4 /*yield*/, getPosition()];
                    case 1:
                        position = _a.sent();
                        return [4 /*yield*/, getPlaceNameAsync(position.coords.latitude, position.coords.longitude)];
                    case 2:
                        placeName = _a.sent();
                        return [2 /*return*/, placeName];
                    case 3:
                        error_2 = _a.sent();
                        if (!(error_2.code === error_2.PERMISSION_DENIED)) return [3 /*break*/, 5];
                        console.error("Geolocation permission denied. Using default location.");
                        defaultLatitude = 0;
                        defaultLongitude = 0;
                        return [4 /*yield*/, getPlaceNameAsync(defaultLatitude, defaultLongitude)];
                    case 4: // default longitude
                    return [2 /*return*/, _a.sent()];
                    case 5:
                        console.error("Error getting current position:", error_2);
                        throw error_2;
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    var handleLanguageChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var pageLanguage, span, anchor, url, pathParts, currentUTCDateTime, placeName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pageLanguage = "en";
                    span = event.target;
                    anchor = span.closest('a');
                    url = anchor.href;
                    pathParts = url.split('/');
                    if (pathParts.length > 2) {
                        pageLanguage = pathParts[3];
                    }
                    currentUTCDateTime = getUtcTime();
                    if (!navigator.geolocation) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCurrentPlaceName()];
                case 1:
                    placeName = _a.sent();
                    sendGAEvent('language_click', {
                        'user_id': userId,
                        'page_language': pageLanguage,
                        'utc_time': currentUTCDateTime,
                        'location': placeName
                    });
                    return [3 /*break*/, 3];
                case 2:
                    sendGAEvent('language_click', {
                        'user_id': userId,
                        'page_language': pageLanguage,
                        'utc_time': currentUTCDateTime,
                        'location': 'N/A'
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var sendGAEvent = function (eventName, eventParams) {
        var googleAnalyticsSettings = $(".header__mobile-menu-wrapper").data("google-analytics");
        var acceptance = (0, GoogleAnalytics_1.getCookieCategoriesAcceptance)();
        if (acceptance && acceptance.statistic) {
            gtag('config', googleAnalyticsSettings.tagManagerId);
            gtag('event', eventName, eventParams);
        }
    };
    var getUtcTime = function () {
        var now = new Date();
        var year = now.getUTCFullYear();
        var month = now.getUTCMonth() + 1; // Months are zero-indexed, so we add 1
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        var minutes = now.getUTCMinutes();
        var seconds = now.getUTCSeconds();
        var milliseconds = now.getUTCMilliseconds();
        // Formatting the UTC date and time components
        var formattedDateTime = "".concat(year, "-").concat(month < 10 ? '0' : '').concat(month, "-").concat(day < 10 ? '0' : '').concat(day, " ").concat(hours < 10 ? '0' : '').concat(hours, ":").concat(minutes < 10 ? '0' : '').concat(minutes, ":").concat(seconds < 10 ? '0' : '').concat(seconds, ".").concat(milliseconds);
        return formattedDateTime;
    };
    return (React.createElement("ul", { className: "app-switcher__content__list ".concat(listClass ? listClass : "") }, (0, app_1.safe)(items).map(function (item, i) {
        return (React.createElement("li", { key: "".concat(item.link + i), className: "".concat(itemClass ? itemClass : "") },
            React.createElement("a", { href: item.link, target: "_self", rel: "noopener", onClick: handleLanguageChange },
                (item.isSelected) ? (React.createElement("span", { className: "image" },
                    React.createElement("img", { src: checkMark }))) : null,
                React.createElement("span", { className: "text" }, item.countryLanguage))));
    })));
};
exports.AppSwitcherItemsList = AppSwitcherItemsList;
